module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "200",
      "src": require("assets/samsung.png"),
      "alt": _vm.pkg.description
    }
  })]), _vm._v(" "), ((_vm.isAdmin || _vm.isHomenetDev)) ? _c('div', {
    staticClass: "has-text-left label"
  }, [_vm._v("Change the below values to reflect in other service pages:")]) : _vm._e(), _vm._v(" "), _c('Resident', {
    ref: "residentRef",
    attrs: {
      "userVisible": _vm.userVisible,
      "getServerData": _vm.getServerData
    },
    on: {
      "partnerChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.PARTNER)
      },
      "complexChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.COMPLEX)
      },
      "buildingChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.BUILDING)
      },
      "houseChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.HOUSE)
      },
      "userChanged": function($event) {
        _vm.storeResident(_vm.RESIDENT_LEVEL.USER)
      }
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v(_vm._s(_vm.pkg.name.replace(/-/gi, ' ')))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.pkg.description))]), _vm._v(",\n    "), _c('a', {
    attrs: {
      "href": _vm.pkg.homepage
    }
  }, [_vm._v("Live Demo")])])], 1)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65809695"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"_CLIENT_ID_PLACE_HOLDER_","replace":"lfms21abk334e3i1lnkpr70ep"},{"search":"_BASE_API_PLACE_HOLDER_","replace":"https:/homeiottf-dev.auth.ap-northeast-2.amazoncognito.com"},{"search":"_CALLBACK_URL_HOLDER_","replace":"https:/www.homeiottf.com"}]}!./client/views/Home.vue